/**
 * VERSE CLINIC — Curated Treatment Catalogue
 *
 * PRESET_TAGS  → 10 featured tags shown as clickable pills on Step 3.
 * ALL_TREATMENTS → Full curated catalogue (~400+). Used for autocomplete search.
 *                  Includes presets + extended list. No free text allowed.
 */

export const PRESET_TAGS = [
  'Genetic Testing',
  'Health Screening',
  'Stem Cells',
  'NAD+',
  'Exosome',
  'VERSE BioAge\u2122',
  'Skin Lifting',
  'Skin Pigmentation',
  'Skin Rejuvenation',
  'Facials',
];

export const ALL_TREATMENTS = [
  // ── Preset featured tags ──────────────────────────────────────
  'Genetic Testing',
  'Health Screening',
  'Stem Cells',
  'NAD+',
  'Exosome',
  'VERSE BioAge\u2122',
  'Skin Lifting',
  'Skin Pigmentation',
  'Skin Rejuvenation',
  'Facials',

  // ── Additional featured (from v2) ─────────────────────────────
  'Immune Shield',
  'Radiance Glow',
  'Liver Detox',
  'Bio-performance',
  'NK Cell',

  // ── IV & Infusion Therapies ───────────────────────────────────
  'NAD+ IV Therapy',
  'High-Dose NAD+ Protocol',
  'Immune Shield IV',
  'Radiance Glow IV',
  'Liver Detox IV',
  'Slim Sculpt IV',
  'Energy Boost IV',
  'Hydration IV Therapy',
  'Glutathione IV',
  'Vitamin C IV',
  'Metabolism Boost IV',
  'Anti-Fatigue IV',
  'Executive Recovery IV',
  'Jet Lag Recovery IV',
  'Athletic Recovery IV',
  'Beauty Drip IV',
  'Brain Focus IV',
  'Stress Relief IV',
  'Longevity IV Program',
  'Mitochondrial Support IV',
  'Immunity Defense IV',
  'Hormone Support IV',
  'Detox Infusion Therapy',
  'Skin Brightening IV',
  'Hair Health IV',
  'Anti-Inflammatory IV',
  'Wellness Maintenance IV',
  'Cellular Repair Infusion',
  'Anti-Oxidant Infusion',
  'Performance IV Therapy',
  'Travel Recovery Drip',
  'Metabolic Reset Infusion',
  'Recovery Enhancement IV',
  'Vitality Recharge IV',
  'Immune Prime Infusion',
  'Collagen Support IV',
  'Energy Recharge Drip',
  'Total Wellness IV',
  'Signature Infusion Therapy',
  'Platinum IV Package',

  // ── Regenerative & Longevity ──────────────────────────────────
  'Stem Cell Therapy',
  'Exosome Therapy',
  'NK Cell Therapy',
  'Peptide Therapy',
  'Cellular Regeneration Program',
  'Telomere Length Assessment',
  'Epigenetic Age Test',
  'Hormone Profile Test',
  'Comprehensive Health Screening',
  'Executive Wellness Screening',
  'Gut Microbiome Test',
  'Heavy Metal Screening',
  'Inflammatory Marker Panel',
  'Metabolic Health Assessment',
  'Oxidative Stress Test',
  'Cardiovascular Risk Panel',
  "Men's Health Screening",
  "Women's Health Screening",
  'Thyroid Function Test',
  'Insulin Resistance Test',
  'Vitamin Deficiency Panel',
  'Adrenal Function Test',
  'Cancer Marker Screening',
  'Bone Health Assessment',
  'Liver Function Test',
  'Kidney Function Test',
  'Cholesterol Profile',
  'Preventive Health Evaluation',
  'Longevity Optimization Program',
  'Biohacking Optimization',
  'Immune Reset Program',
  'Recovery Enhancement Therapy',
  'Anti-Burnout Program',
  'Cognitive Enhancement Program',
  'Sleep Restoration Therapy',
  'Cellular Detox Program',
  'Advanced Wellness Diagnostics',
  'Personalized Longevity Plan',

  // ── Biohacking & Recovery ─────────────────────────────────────
  'Hyperbaric Oxygen Therapy',
  'Photobiomodulation Therapy',
  'Red Light Therapy',
  'Low-Level Laser Therapy',
  'Oxygen Longevity Program',
  'IV Ozone Therapy',
  'Cryotherapy Session',
  'Infrared Sauna Therapy',
  'Cold Plunge Therapy',
  'Contrast Therapy Session',
  'Compression Recovery Therapy',
  'Floatation Therapy',
  'PEMF Therapy',
  'Neurofeedback Training',
  'Breathwork Optimization',
  'Performance Coaching',
  'Metabolic Conditioning Session',
  'Hormonal Optimization Program',
  'Immune Strength Program',
  'Vitality Enhancement Program',
  'Cellular Activation Therapy',
  'Regeneration Support Program',
  'Recovery Lounge Session',
  'Oxygen Recovery Chamber',
  'Bio-Optimization Membership',
  'Elite Performance Program',
  'Stress Adaptation Therapy',
  'Athletic Conditioning Program',
  'Resilience Training Program',
  'Executive Biohacking Package',

  // ── Lifting & Tightening Devices ──────────────────────────────
  'Ultherapy PRIME',
  'Thermage FLX',
  'Sofwave',
  'Oligio',
  'Oligio X',
  'Ultraformer MPT',
  'Doublo Gold',
  'HIFU Lifting',
  'EndyMed PRO',
  'Accent Prime',
  'Sylfirm X',
  'Potenza RF',
  'Morpheus8',
  'Secret RF',
  'Venus Viva',
  'Venus Legacy',
  'Venus Bliss',
  'ONDA Coolwaves',
  'Vanquish ME',
  'Emsculpt Neo',
  'CoolSculpting',
  'CoolSculpting Elite',
  'ZLipo',
  'BTL Exilis',
  'BTL Vanquish',
  'RF Body Tightening',
  'Muscle Toning Therapy',
  'Cellulite Reduction Therapy',
  'Skin Firming Body Treatment',
  'Non-Surgical Body Sculpt',
  'Neck Tightening Procedure',
  'Jawline Definition Treatment',
  'Facial Contouring Procedure',
  'V-Shape Face Sculpt',
  'Double Chin Reduction',
  'Body Remodeling Program',
  'Postpartum Body Recovery',
  'Abdominal Tightening Treatment',
  'Arm Firming Treatment',
  'Thigh Contouring Treatment',

  // ── Laser Platforms ───────────────────────────────────────────
  'PicoSure Laser',
  'PicoWay Laser',
  'Pico Laser Treatment',
  'Hollywood Spectra',
  'Fotona StarWalker MaQX',
  'Fotona SP Dynamis',
  'Spectra Laser',
  'Laser Genesis',
  'Candela GentleMax Pro',
  'Lutronic Clarity II',
  'Excel V Laser',
  'Clear + Brilliant',
  'CO2 Fractional Laser',
  'Erbium YAG Laser',
  'eCO2 Laser',
  'Carbon Laser Facial',
  'IPL Photofacial',
  'BB Laser Treatment',
  'Tattoo Removal Laser',
  'Pigment Laser Treatment',
  'Acne Scar Laser',
  'Melasma Laser Treatment',
  'Vascular Lesion Laser',
  'Rosacea Laser Therapy',
  'Skin Resurfacing Laser',
  'Laser Pore Refinement',
  'Laser Toning Treatment',
  'Laser Skin Polishing',
  'Laser Brightening Therapy',
  'Laser Pigment Correction',
  'Laser Scar Revision',
  'Laser Tightening Therapy',
  'Stretch Mark Laser',
  'Laser Neck Rejuvenation',
  'Laser Hand Rejuvenation',
  'Laser D\u00e9colletage Treatment',
  'Laser Hair Removal',
  'Diode Laser Hair Removal',
  'Alexandrite Laser Treatment',
  'Nd:YAG Laser Treatment',
  'Q-Switched Laser',
  'Fractional Resurfacing',
  'Ablative Laser Procedure',
  'Non-Ablative Laser Procedure',
  'Dual Wavelength Laser',
  'Triple Wavelength Laser',
  'Advanced Pigment Protocol',
  'Rejuvenation Laser Series',
  'Precision Laser Treatment',
  'Elite Laser Package',

  // ── Facials & Skin Therapies ──────────────────────────────────
  'HydraFacial',
  'Intraceuticals Oxygen Infusion',
  'OxyGeneo Facial',
  'Medical Grade Facial',
  'Chemical Peel',
  'Microdermabrasion',
  'LED Light Therapy',
  'Deep Cleansing Facial',
  'Luxury Signature Facial',
  'Enzyme Peel Facial',
  'Diamond Peel Treatment',
  'Acne Clarifying Treatment',
  'Hydrating Facial Therapy',
  'Sensitive Skin Treatment',
  'Skin Detox Facial',
  'Anti-Aging Facial',
  'Collagen Renewal Facial',
  'Radiance Boost Facial',
  'Pore Refining Facial',
  'Brightening Facial',
  'Gold Infusion Facial',
  'Platinum Glow Facial',
  'Korean Glass Skin Treatment',
  'Oxygen Dome Therapy',
  'Calming Skin Therapy',
  'Barrier Repair Treatment',
  'Elasticity Enhancement Therapy',
  'Texture Refinement Therapy',
  'Oil Control Therapy',
  'Scar Improvement Treatment',
  'Freckle Removal Treatment',
  'Dark Spot Removal',
  'Under Eye Rejuvenation',
  'Hand Rejuvenation',
  'D\u00e9colletage Rejuvenation',
  'Neck Rejuvenation',
  'Acne Management Program',
  'Rosacea Management',
  'Skin Balancing Treatment',
  'Complexion Correction Therapy',
  'Firming Facial',
  'Glow Maintenance Facial',
  'Youth Revival Treatment',
  'Express Facial Treatment',
  'Premium Skin Therapy',
  'Signature Glow Therapy',
  'Advanced Rejuvenation Facial',
  'Bright Complexion Program',
  'Clarity Skin Program',
  'Ultimate Facial Package',

  // ── Injectables & Biostimulators ──────────────────────────────
  'Skin Booster Injection',
  'Profhilo',
  'Rejuran Healer',
  'Juvederm',
  'Restylane',
  'Belotero',
  'Sculptra',
  'Radiesse',
  'Ellans\u00e9',
  'AestheFill',
  'Juvelook',
  'HarmonyCa',
  'Neauvia',
  'Teosyal',
  'Stylage',
  'Botox',
  'Dysport',
  'Xeomin',
  'Thread Lift',
  'Mint Thread Lift',
  'PDO Thread Lift',
  'Silhouette Soft',
  'PRP Skin Rejuvenation',
  'PRP Hair Therapy',
  'Dermapen 4',
  'SkinPen',
  'AquaGold Fine Touch',
  'Collagen Biostimulator',
  'Liquid Facelift',
  'Non-Surgical Rhinoplasty',
  'Chin Augmentation',
  'Lip Augmentation',
  'Temple Enhancement',
  'Cheek Volume Restoration',
  'Tear Trough Correction',
  'Brow Lift Injection',
  'Nasolabial Fold Correction',
  'Marionette Line Correction',
  'Facial Slimming Injection',
  'Masseter Reduction Treatment',
  'Neck Line Treatment',
  'Gummy Smile Correction',
  'Jawline Contouring',
  'Full Face Rejuvenation',
  'Preventive Anti-Wrinkle Treatment',
  'Micro-Injection Therapy',
  'Skin Revitalization Injection',
  'Volume Restoration Treatment',
  'Facial Harmonization Treatment',
  'Personalized Injectable Plan',
  'Bio-Stimulator Injection',
  'Hybrid Filler Treatment',
  'Deep Hydration Injection',
  'Skin Density Enhancement',
  'Facial Profile Enhancement',
  'Customized Contour Plan',
  'Regenerative Injection Therapy',
  'Premium Filler Package',
  'Signature Contouring Package',
  'Elite Injectable Program',

  // ── Hair, Weight & Programs ───────────────────────────────────
  'Hair Restoration Therapy',
  'Scalp Revitalization Treatment',
  'Hair Growth Program',
  'Hair Loss Assessment',
  'PRP Scalp Therapy',
  'Exosome Hair Treatment',
  'Stem Cell Hair Restoration',
  'Low-Level Laser Hair Therapy',
  'Hair Density Optimization',
  'Scalp Detox Treatment',
  'Follicle Activation Therapy',
  'Hair Nutrient Infusion',
  'Microneedling for Scalp',
  'Anti-Hair Loss Program',
  'Female Hair Wellness Program',
  'Male Pattern Hair Program',
  'Weight Management Program',
  'Hormone Balance Program',
  'Detox & Cleanse Program',
  'Metabolic Reset Program',
  'Healthy Aging Program',
  'Executive Vitality Program',
  'Corporate Wellness Program',
  'Lifestyle Optimization Program',
  'Total Wellness Program',
  'Premium Rejuvenation Package',
  'Signature Aesthetic Package',
  'Platinum Longevity Package',
  'Elite Biohacking Program',
  'Annual Wellness Membership',
  'Personalized Treatment Plan',
  'Medical Aesthetic Consultation',
  'Regenerative Consultation',
  'IV Drip Consultation',
  'Doctor Consultation',
  'Wellness Strategy Session',
  'Body Transformation Program',
  'Preventive Care Program',
  'Immunity Optimization Program',
  'Stress Management Program',
  'Sleep Optimization Program',
  'Energy Enhancement Program',
  'Vitality Maintenance Plan',
  'Anti-Fatigue Program',
  'Brain Optimization Program',
  'Mood Balance Program',
  'Performance Enhancement Program',
  'Recovery Optimization Program',
  'Longevity Membership',
  'Signature Wellness Experience',
  'Elite Rejuvenation Plan',
  'Advanced Biohacking Package',
  'Preventive Longevity Package',
  'Executive Health Membership',
  'Personalized Anti-Aging Plan',
  'Youth Preservation Program',
  'Wellness Concierge Service',
  'Platinum Body Program',
  'Premium Skin Program',
  'Regenerative Health Package',
  'Ultimate Glow Package',
  'Full Face Renewal Plan',
  'Advanced Contouring Program',
  'Cellular Vitality Package',
  'Medical Wellness Package',
  'Signature Bio-Optimization',
  'Advanced Aesthetic Membership',
  'Elite Recovery Membership',
  'Total Longevity Experience',
  'Annual Bio-Age Tracking',
  'Preventive Diagnostics Program',
  'VIP Wellness Membership',
  'Comprehensive Rejuvenation Plan',
  'Holistic Health Program',
  'Lifestyle Reset Program',
  'Transformation Membership',
  'Medical Aesthetic Membership',
  'Elite Preventive Care Plan',
  'Total Optimization Program',
  'Ultimate Longevity Membership',
];

// De-duplicated set for fast lookup (case-insensitive)
const _seen = new Set();
export const UNIQUE_TREATMENTS = ALL_TREATMENTS.filter((t) => {
  const key = t.toLowerCase();
  if (_seen.has(key)) return false;
  _seen.add(key);
  return true;
});
